import React from 'react';

function InGameLeadingTitle () {
    return(
        <div>
            <h1 className="GuideTitle">In Game "Leading"</h1>
            <h2 className="GuideTitleH2">Written By: David "Gatr" Macaulay</h2>
        </div>
    )
}

export default InGameLeadingTitle;